const CATEGORY_COLORS: Record<string, string> = {
  parking: "#00d4ff",
  ada_stencil: "#ff6b6b",
  curved_arrow: "#ffa94d",
  single_empty_stall: "#51cf66",
  double_empty_stall: "#69db7c",
  fire_lane: "#ff4444",
  hash_area: "#ffd43b",
  no_parking_lane: "#ff922b",
  other_stencil: "#845ef7",
  speed_bump: "#fab005",
  stop_stencil: "#f03e3e",
  straight_arrow: "#20c997",
  visitor_lane: "#339af0",
  single_occupied_stall: "#51cf66",
  ada_single_stall: "#51cf66",
  ada_single_stalls: "#51cf66",
  double_occupied_stall: "#69db7c",
};

const FALLBACK_PALETTE = [
  "#00d4ff",
  "#51cf66",
  "#ff6b6b",
  "#ffa94d",
  "#845ef7",
  "#ffd43b",
  "#339af0",
  "#e64980",
];

/** Categories offered when manually adding a detection. */
export const AI_MAPPING_CATEGORIES = [
  "parking",
  "single_empty_stall",
  "double_empty_stall",
  "ada_stencil",
  "curved_arrow",
  "straight_arrow",
  "fire_lane",
  "hash_area",
  "no_parking_lane",
  "other_stencil",
  "speed_bump",
  "stop_stencil",
  "visitor_lane",
];

export const AI_MAPPING_STALL_GROUPS: Record<string, "single_stalls" | "double_stalls"> = {
  single_empty_stall: "single_stalls",
  single_occupied_stall: "single_stalls",
  ada_single_stall: "single_stalls",
  ada_single_stalls: "single_stalls",
  double_empty_stall: "double_stalls",
  double_occupied_stall: "double_stalls",
};

/** djb2 string hash — tiny and deterministic. */
const hashCategory = (category: string): number => {
  let hash = 5381;
  for (let i = 0; i < category.length; i += 1) {
    hash = (hash * 33) ^ category.charCodeAt(i);
  }
  return Math.abs(hash);
};

export function getCategoryColor(category: string, apiColor?: string | null): string {
  if (apiColor) return apiColor;
  const known = CATEGORY_COLORS[category];
  if (known) return known;
  return FALLBACK_PALETTE[hashCategory(category) % FALLBACK_PALETTE.length];
}

export function getCategoryLabel(category: string): string {
  if (!category) return "Unknown";
  if (category === "single_stalls") return "Single Stalls";
  if (category === "double_stalls") return "Double Stalls";
  const words = category.replace(/[_-]+/g, " ").trim();
  return words
    .split(" ")
    .map((word) => (word ? word.charAt(0).toUpperCase() + word.slice(1) : word))
    .join(" ");
}

export function getPricingGroupCode(category: string): string {
  return AI_MAPPING_STALL_GROUPS[category] ?? category;
}

export function isStallGroup(category: string): boolean {
  return category === "single_stalls" || category === "double_stalls" || AI_MAPPING_STALL_GROUPS[category] != null;
}
